export const orderStatuses = {
  DRAFT: 1,
  DECLARED: 5,
};